module.exports = __webpack_public_path__ + "img/icon-veggies.9dc4b483.svg";